<template style="">
  <div class="Game_a_type">
    <!-- 第一屏 -->
    <div v-show="IsGame==1" style="height: 100%;">
      <el-row :gutter="20" style="display: flex;align-items: center;">
        <el-col :span="6" :offset="2">
          <img src="http://192.168.1.211:8008/GameMng/Images/%E7%9F%AD%E6%97%B6%E8%AE%B0%E5%BF%86%E5%8A%9B.png"  style="width: 100%;">
        </el-col>
        <el-col :span="12">
          <h2>短时记忆力</h2>
          <label style="padding:5px 0;display:block;">训练描述：</label>
          <p>这是一个提高你短时记忆力的训练。以下每一题中，画面会呈现一组字母（数字），一段时间后消失。随后呈现一些单个字母或数字，请判断它们是否在之前的字母组（数字组）中出现过，如果出现过请按【是】键，没有出现过按【否】键。明白指导语后请开始训练。</p>
          <el-button type="primary" round style="margin: 20px 0;" @click="IsGame=2">开始训练</el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 难度选择 -->
    <div v-show="IsGame==2" style="height: 100%;">
      <el-row :gutter="20" style="display: flex;align-items: center;justify-content: center;">
        <el-col :span="16" class="gamebg">
          <span class="title">难度选择</span>
          <el-table
            :data="tableData"
            style="width: 640px;margin: 80px auto 0;">
            <el-table-column
              label="难度"
              width="180">
              <template v-slot="scope">
                <div style="display: flex;align-items: center;">
                  <span style="float: left;padding-left: 20px;">{{ scope.row.difficulty==1?'简单':scope.row.difficulty==2?'正常':'困难'}}</span>
                  <div style="text-align: left;"><img v-for="item of scope.row.difficulty" src="../../assets//game/start.png" style="width: 28px;"></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="characterlength"
              label="字符长度"
              width="80">
            </el-table-column>
            <el-table-column
              prop="questionsnum"
              label="题目数量"
              width="80">
            </el-table-column>
            <el-table-column
              prop="presentation"
              label="靶刺激呈现时间">
            </el-table-column>
            <el-table-column
              prop="presentation2"
              label="探查刺激呈现时间">
            </el-table-column>
          </el-table>

          <div style="display: flex;justify-content: center;margin: 70px 0 0;">
            <el-button type="primary" round style="margin-right: 50px;">开始</el-button>
            <el-button round style="margin-right: 50px;" @click="IsGame=1">取消</el-button>
            <el-button type="primary" round>开始生理监测</el-button>
          </div>

        </el-col>

      </el-row>
    </div>
    
    <!-- 答题 -->
    <div v-show="IsGame==3">
      <el-row :gutter="20">
        <el-col :span="20">
          <div class="grid-content bg-purple Game_a_type_left" style="padding-top: 50px;">
            <div style="width: 80%;margin-left: 10%;background-color: rgba(214,204,191,1);height: calc(50% - 160px);position: relative;">

              <div v-if="judgment" style="position: absolute;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;width: 200px;height: 60px;font-size: 24px;color: rgba(116,96,60,1);">
                {{ num }}
              </div>

              <div v-else style="position: absolute;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;width: 200px;height: 60px;font-size: 24px;color: rgba(116,96,60,1);">
                请输入:<el-input @input="jiangting()" v-model="input" placeholder="请输入内容"></el-input>
              </div>
              <!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
            </div>

            <div style="width: 80%;margin-left: 10%;background-color: rgba(214,204,191,1);height: calc(50% - 160px);margin-top: 50px;position: relative;">
              <ul class="keyboard">
                <li v-for="item of NumberList" @click="ClickNum(item)">{{item}}</li>
              </ul>
            </div>
          </div>
        </el-col>

        <el-col :span="4">
          <div style="height: 100%;" class="grid-content bg-purple">
            <ul class="Game_a_type_right">

              <li>
                <h3 style="text-align: center;padding-top: 30px;color: rgba(201,162,88,1);">记忆广度</h3>
                <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">正确数:{{ correct }}</p>
                <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">错误数：{{ error }}</p>
              </li>

              <li>
                <h3 style="text-align: center;padding-top: 55px;color: rgba(201,162,88,1);">
                  <p>剩余时间</p>
                  <p style="font-size: 24px;color: red;margin-top: 20px;">{{ myTime }}</p>
                </h3>
              </li>

              <li>
                <p style="text-align: center;padding-top:50px;"><el-button type="primary" @click="Startover()">重新开始</el-button></p>
                <p style="text-align: center;margin-top: 20px;"><el-button type="primary">难度选择</el-button></p>
                <p style="text-align: center;margin-top: 20px;"><el-button type="primary" @click="Clickexit">退出    </el-button></p>
              </li>

            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
var timer='';
export default {
  data() {
    return {
      IsGame:1,
      editableTabs: sessionStorage.getItem('OpenTabs') && sessionStorage.getItem('OpenTabs') != '' ? JSON.parse(sessionStorage.getItem('OpenTabs')) : [ sessionStorage.getItem('entity') == '管理员' ? { title: '工作台', name: 'Set_basis', path: '/Set/Set_basis',} : sessionStorage.getItem('entity') == '咨询师' ? { title: '工作台',  name: 'ConsultantWork', path: '/Consultant/ConsultantWork', } : { title: '首页', name: 'index',  path: '/index'}],
      NumberList:[0,1,2,3,4,5,6,7,8,9],
      myFaultCount: '',//剩余数
      myTimeCount: 0, //总时间
      myTime: 1, //呈现时间
      input: '',
      judgment: true,
      judgmentnum: 1,//判断数量是非到5
      num: '',//生成的数
      correct: 0,//正确数
      error : 0,//错误数

      tableData: [
        {
          difficulty:1,
          characterlength:3,
          questionsnum:1,
          presentation:15,
          presentation2:15,
        },{
          difficulty:2,
          characterlength:6,
          questionsnum:1,
          presentation:10,
          presentation2:10,
          },{
          difficulty:3,
          characterlength:3,
          questionsnum:1,
          presentation:5,
          presentation2:5,
          }]
    }
  },
  mounted() {
    // this.Time(this.myTimeCount);
    // this.Times(3);
    // this.RandomNumbers()
  },
  methods: {
    // 重新开始
    Startover(){
    this.myTimeCount=0;
    clearInterval(timer);
    this.Time(this.myTimeCount);
    this.RandomNumbers()
    },
    jiangting() {
      if (this.judgmentnum > 6) {
        if (this.input.length == 4) {
          this.Right_or_wrong(this.input);
          this.num = "";
          this.input = "";
          this.Times(3);
          clearInterval(timer);
          this.RandomNumbers();
          if (this.judgmentnum > 11) { 
            alert("结束")
          }
        }
      } else {
        if (this.input.length ==3) {
          this.Right_or_wrong(this.input);
          this.input = "";
          this.num = "";
          this.Times(3);
          this.Time(0);
          clearInterval(timer);
          this.RandomNumbers();
        }
      }
    },

    // 点击数字
    ClickNum(e){
      if(this.judgment){
        return false;
      }
      this.input+=e;
      this.jiangting();
    },

    Right_or_wrong(val) {
      if (val == this.num) {
        this.correct++
      } else {
        this.error++
      }
    },

    Time(time) {//倒计时
      this.myTime = parseInt(time / 60) + '分' + (time % 60) + '秒'
      timer = setInterval(() => {
        this.myTime = parseInt(time / 60) + '分' + time % 60 + '秒';
        if (time > 0) {
          time++
        } else {
          time++
        }
      }, 1000)
    },



    Times(time) {//倒计时
      this.judgment = true
      let timers = setInterval(() => {
        if (time > 0) {
          time--
        } else {
          clearTimeout(timers)
          this.judgment = false
        }
      }, 1000)
    },

    RandomNumbers() {
      let Nowchar = Math.floor(Math.random() * 10);//生成0-9的随机数
      if (this.judgmentnum > 5) {
        this.judgmentnum++
        for (var i = 0; i < 4; i++) {
          let Nowchar = Math.floor(Math.random() * 10);
          this.num = this.num + Nowchar;
        }
      } else {
        this.judgmentnum ++ 
        for (var i = 0; i < 3; i++) {
          let Nowchar = Math.floor(Math.random() * 10);
          this.num = this.num + Nowchar;
        }
      }
    },

    // 退出
    Clickexit(){

    },

    submit() {//提交函数
      // alert("提交函数")
    },
    
  }
}

</script>

<style>
  .Game_a_type thead th{background: none !important;color:#b18f4f;}
  .Game_a_type .has-gutter tr,.Game_a_type .el-table__body{background:#efeee4;}
  .Game_a_type .el-table th.is-leaf{border: none;}
  .Game_a_type{width: 100%;height: calc(100% - 50px);}
  .Game_a_type tbody tr{background:#d8d7ca;margin: 10px 0;}
  .Game_a_type tbody tr:hover > td {
            background: #b18f4f !important;
        }
  .Game_a_type tbody tr td{border:none;text-align: center;}
  .Game_table{height: 100%;width: 100%;position: relative;}
  /* .Game_a_type tr{float: left;} */
  .Game_a_type .el-row{height: 100%;}
  .Game_a_type .el-col-20{height: 100%;}
  .Game_a_type .el-col-4{height: 100%;}

  .Game_a_type_left{height: 100%;background-image: url('../../assets/div3_left1.png');background-size: 100% 100%;background-color: #C4E8DC;}

  .Game_a_type_right li{margin-top: 15px;}
  .Game_a_type_right{height: 100%;}
  .Game_a_type_right li:nth-child(1){height: 30%;background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;margin-top: 0px;}

  .Game_a_type_right li:nth-child(2){height: 20%;background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;}
  .Game_a_type_right li:nth-child(3){height: calc(50% - 25px);background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;}

  .Game_table td{text-align: center;line-height: 40px;}
  .keyboard{position: absolute;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;height: 40px;width: 520px;}
  .keyboard li{width: 40px;height: 40px;text-align: center;line-height: 40px;float: left;border: 1px solid #C9C9C9;background-color: #fff;border-radius: 10px;margin-left: 10px;cursor: pointer;}

  .gamebg{background: url("../../assets/game/difficulty_bg.png") 100% no-repeat;width: 776px;height:582px;position: relative;background-size: 100%;}
  .gamebg .title{color: #fff;text-align: center;display: block;font-size: 30px;padding-top: 10px;}
  .el-table__body {
    -webkit-border-vertical-spacing: 10px; 
  }
</style>
